import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetListGameFreespin = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_GAME_FS
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetListGameFreespinAction({
                    data: data.data,
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetListGameFreespin as SetGetListGameFreespin
}